import { trackPageRequest } from './appComponents/shared/PageLoadingService';
import { authenticatedPut } from './appComponents/shared/AuthenticatedAPI';
import Amplify, { Auth, Storage, API } from 'aws-amplify'
import { ReactSearchAutocomplete } from 'react-search-autocomplete'

import './../styles/Browser.css'; // Tell webpack that Button.js uses these styles
import './../index.css';
import React, {Component, Fragment, useRef, useLayoutEffect} from 'react';


import blenderCommissionPublicKey from '../blenderData/blenderCommissionPublicKey.js';
import blenderTransfersToPublicKey from '../blenderData/blenderTransfersToPublicKey.js';
import { Chart } from 'react-google-charts';
import {isMobile} from 'react-device-detect';

import { 
  LineChart,
  Bar,
  XAxis,
  YAxis,
  Line,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from "recharts";
import { Mosaic, OrbitProgress, ThreeDot } from "react-loading-indicators";

import awsconfig from '../aws-exports.js';
import { navigationHandler, routeProps } from '../utilities/navigator.js';
import LoadingIcons from 'react-loading-icons'
import blenderPrivateKey  from '../blenderData/generalPrivateKey.js';
import { tokenLifeTimeLimit, checkValidAuthTokenIntervalPeriod_ms,  LENDERBLOCKADMINWHITELIST} from '../blenderData/securityConfigurations.js';
import { Link, useParams } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css'
import { 
  Button, 
  ButtonContent,
  ButtonGroup,
  Modal, 
  Header, 
  Image, 
  Container,
  ListList,
  ListItem,
  ListIcon,
  Icon,
  Input,
  ListHeader,
  ListDescription,
  ListContent,
  List,
  FormField, 
  Form, 
  Radio,
} from 'semantic-ui-react';
import { ethers } from 'ethers';
import axios from 'axios';


import CampaignContract_latest from '../ethereum/build/latest/Campaign.json';
import CampaignFactoryContract_latest from '../ethereum/build/latest/CampaignFactory.json';
import MemberTransactionsMobileRender from './memberTransactions/MemberTransactionsMobileRender.jsx';
import MemberTransactionsDesktopRender from './memberTransactions/MemberTransactionsDesktopRender.jsx';

var primaryLanguage;
var mode_light_dark;

const Web3 = require('web3');
const CryptoJS = require("crypto-js");

var AWS = require('aws-sdk');

var mimemessage = require('mimemessage');


AWS.config.update({region:'us-east-1'});

const secretName = "PrivateBlenderKeys"
const region = 'us-east-1'

Amplify.configure(awsconfig);
Auth.configure(awsconfig);

var contractAddress;

var cognitoID;

var web3;
var highRateWeb3;

let client;

var campaign;
var publicKey;
var rand1;
var that; 
var blenderPercentCharge = 0.0500;

let primaryDisplayCurrency;
let secondaryDisplayCurrency;
let primaryDisplayPrice;
let secondaryDisplayPrice;
let forexJSON;


var privateKey;

var contributeSignatureNeeded;

var thisDeploymentAddress;

var value;
var valueDelta;
let proposeGasPrice;
var displayValue;

var borrowerStatsArray = [];
var accountStatsArray = [];

var _payableValue
var _approversCt
var _web3Balance
var _targetValue
var _minLoan
var _blockchainBalance
var _totalWithdrawn
var _userContributed
var _userFinalized
var _totalPaid 
var _totalContributedWei
var _totalContributed 
var _approversLoanTotal 
var _borrowerInterestPaid 

var noDailyDataPointsFoundBool

var transactionValue;
var requests = []
var wishlist;
var wishlistIcon;

var contractReceipts;

var corporateBackedUsernamesArray
let isSubscribedCurrentBool = false;

var emailAddress
var _txnSectionHelpText
var _approversLoanTotal
var _availableCreditReadyWithdraw
var _minLoan;
var _totalContributed;
var _balance;
var _dateCreated;
var _riskCoverage;
var _intRate;
var _offeredLenderCommissionUSD_adjusted
var managerDisplay;
var _openValue;
var _blenderScore;
var _fico;
var _totalLending;
var _totalBorrowing;
var _lentTotal;
var _borrowingRec;
var _loanRate;
var _withdrawalRate;
var _lendingRate;
var _repayRate;
var _joinDate;
var _repaymentTotal;
var _lenders;
var _currentUserContribution;

var _managerLCase
var _lookupKey
let _values = [[{'type': 'string', 'id': 'Date'}, {'type': 'number', 'id': 'Avail. Balance'}, {'type': 'string', 'role': 'tooltip', 'p': {'html': true}} ]];
let _valuesONLY = ''
var dataIndexDayMap = {};
var _userAvgRating;
var _totalContributedWei;
var _totalWithdrawn;
var _userContributed;
var _userFinalized;
var _userInterestEarned;
var _approverReceivedRepaymentSum;
var _borrowerInterestPaid;
var _totalPaid;
var _reclaimableValue;
var _exitReclaimableValueWei;
var _safeReclaimableValueWei;
var _weiCompoundedBalance;
var _compoundedBalance;
var _canDeleteCreditLineBool;
var _compoundedBalanceWEI;
var netDebt;

var squareCustomerID;
var actionText;
var costText;
var buttonText;
var interactionHeader;
var actionButton;
var actionType;
let actionTypeStakingBool;
var contractAddress
var contractBalance;
var lenderCount;
var intRate;
var openValue;
var minLoan;
var totalPaid;
var totalWithdrawn;
var totalValue;
var availableCreditRatio;
var userRiskValue;
var riskCoveragePercentage;
var targetValue;
var blenderScore;
var fico;
var totalLending;
var totalBorrowing;
var repaidRec;
var borrowingRec;
var loanRate;
var withdrawalRate;
var lendingRate;
var repayRate;
var currentUser;
var managerUsername;
var userContributed;
var userFinalized;
var userInterestEarned;
var borrowerInterestPaid;
var openContracts;

let mediaMapArrayUserMap = {}

var currentUserCap;

var tooltipInterval;
var formattedValueTooltipString
var maxDayValue
var minDayValue
var blacklisted;
var web3BalancePre;
var web3BalancePost;
var loanTarget;
var minimumContribution;
var interestRate;
var finalRequestsSum;
var repaymentSum;
var approverCheck;
var totalContributed;
var availableCredit;
var availableCredit_unadjusted;
var totalCreditMax;
var creditUtilizationPerc;
var approversCount;
var requestsCt;
var receiptsCt;
var approversList;
var approverReceivedRepaymentSum;
var manager;
var currentUserLoanTotal;
var userLiquidValuePre;
var userLiquidValue;
var userFinalizedRequestLoanSum;
var reclaimableValue;
var compoundedInterestPaid;
var compoundInterestReceived;
var insuranceTotal;
var imaginaryInsuranceTotal;
var conversionRateGlobal; 
var deploymentAddress;
var buttonColorFlashIntervalDefault;
var buttonColorFlashIntervalSecondary;
var contractStructureType;
var settlementDateFormatted;
var closureDateFormatted;
var offeredLenderCommissionUSD;
var isCorporateBondBool = false

let mediaArray;
let mediaArrayMap;
let firstName;
let lastName;
let phoneNumber;
let dob;
let ipAddress;
let streetAddress;
let fullAddress;

let loadingTextInterval;
let loadingTextIntervalCt = 0;

var errorWarningOverlayTimeout;


let thisContract_CampaignContract
let thisContract_CampaignFactoryContract

var walletBalanceWei;













let monthLengtheningEnum = {
    JAN: 'January',
    FEB: 'February',
    MAR: 'March',
    APR: 'April',
    MAY: 'May',
    JUN: 'June',
    JUL: 'July',
    AUG: 'August',
    SEP: 'September',
    OCT: 'October',
    NOV: 'November',
    DEC: 'December',
}

class MemberTransactionsComponent extends Component {

  constructor() {
    super()


    this.state = {
      xCoor: 170,
      yCoor: 50,
      xLine: 170,
      yValue: '-',
      xValue: '-',
      trigger: '',
      notifIcon: 'ios-square-outline',
      status: '',
      currentUser: ' ',
      chartData: [0],
      values: [0],
      walletBalance: '-',
      showOverlay: false,
      primaryDisplayPrice: 0,
      secondaryDisplayPrice: 0,
      primaryDisplayCurrency: ' ',
      secondaryDisplayCurrency: ' ',
      forexJSON: null,
      buttonBackgroundColor_1: 'rgba(0, 158, 129, 0.08)',
      buttonBorderColor_1: 'rgba(0, 0, 0, 0)',
      buttonTextColor_1: 'rgba(0, 158, 129, 1)',
      filterBool_1: false,
      buttonBackgroundColor_2: 'rgba(0, 158, 129, 0.08)',
      buttonBorderColor_2: 'rgba(0, 0, 0, 0)',
      buttonTextColor_2: 'rgba(0, 158, 129, 1)',
      filterBool_2: false,
      buttonBackgroundColor_3: 'rgba(0, 158, 129, 0.08)',
      buttonBorderColor_3: 'rgba(0, 0, 0, 0)',
      buttonTextColor_3: 'rgba(0, 158, 129, 1)',
      filterBool_3: false,
      buttonBackgroundColor_4: 'rgba(0, 158, 129, 0.08)',
      buttonBorderColor_4: 'rgba(0, 0, 0, 0)',
      buttonTextColor_4: 'rgba(0, 158, 129, 1)',
      filterBool_4: false,
      buttonBackgroundColor_5: 'rgba(0, 158, 129, 0.08)',
      buttonBorderColor_5: 'rgba(0, 0, 0, 0)',
      buttonTextColor_5: 'rgba(0, 158, 129, 1)',
      filterBool_5: false,
      buttonBackgroundColor_6: 'rgba(0, 158, 129, 0.08)',
      buttonBorderColor_6: 'rgba(0, 0, 0, 0)',
      buttonTextColor_6: 'rgba(0, 158, 129, 1)',
      filterBool_6: false,
      buttonBackgroundColor_7: 'rgba(0, 158, 129, 0.08)',
      buttonBorderColor_7: 'rgba(0, 0, 0, 0)',
      buttonTextColor_7: 'rgba(0, 158, 129, 1)',
      filterBool_7: false,
      buttonBackgroundColor_8: 'rgba(0, 158, 129, 0.08)',
      buttonBorderColor_8: 'rgba(0, 0, 0, 0)',
      buttonTextColor_8:'rgba(0, 158, 129, 1)',
      filterBool_8: false,
      buttonBackgroundColor_9: 'rgba(0, 158, 129, 0.08)',
      buttonBorderColor_9: 'rgba(0, 0, 0, 0)',
      buttonTextColor_9: 'rgba(0, 158, 129, 1)',
      filterBool_9: false,
      dayRangeColor_1: 'rgba(0, 158, 129, 0.08)',
      dayRangeBorderColor_1: 'rgba(0, 0, 0, 0)',
      dayRangeTextColor_1: 'rgba(0, 158, 129, 1)',
      dayRangeColor_2: 'rgba(0, 158, 129, 0.08)',
      dayRangeBorderColor_2: 'rgba(0, 0, 0, 0)',
      dayRangeTextColor_2: 'rgba(0, 158, 129, 1)',
      dayRangeColor_3: 'rgba(0, 158, 129, 0.08)',
      dayRangeBorderColor_3: 'rgba(0, 0, 0, 0)',
      dayRangeTextColor_3: 'rgba(0, 158, 129, 1)',
      dayRangeColor_4: 'rgba(0, 158, 129, 0.08)',
      dayRangeBorderColor_4: 'rgba(0, 0, 0, 0)',
      dayRangeTextColor_4: 'rgba(0, 158, 129, 1)',
      dayRangeColor_5: 'rgba(0, 158, 129, 0.08)',
      dayRangeBorderColor_5: 'rgba(0, 0, 0, 0)',
      dayRangeTextColor_5: 'rgba(0, 158, 129, 1)',
      dayRangeColor_6: 'rgba(0, 158, 129, 0.08)',
      dayRangeBorderColor_6: 'rgba(0, 0, 0, 0)',
      dayRangeTextColor_6: 'rgba(0, 158, 129, 1)',
      chartDayRange: Math.floor(Date.now()/86400000),
      filterView: null,
      selectedLanguage: null,
      receiptList: [],
      currentUserProfilePicture: null,
      moneyTransactionPreset: 'deposit',
      last4AccountNumbers_bankAccount: null,
      destinationUsername: null,
      pendingTransactionLoaderOverlay: false,
      successfulDepositOverlay: false,
      successfulTransferOverlay: false,
      successfulWithdrawalOverlay: false,
      selectedLanguage: null,
      mode_light_dark: null,
      currentUser: null,
      errorTags: null,
      transferCommissionPercentDecimal: 0.05,
      passwordIsHiddenBool: true,
      usernameText: '',
      passwordText: '',
      moneyTransactionLiveValue: null,
      walletBalanceUSD: 0,
      walletBalanceWei: 0,
      maxWalletWithdrawalWei: 0,
      moneyTransferOverlay: false,
      verifyIDOverlay: false,
      activeSearchBorrowerAccountBool: false,
      activeSearchTransferBool: false,
      allUserUsernamesDisplayNames: [],
      activeSearchTransferBool: false
                 } 

    web3 = new Web3(new Web3.providers.HttpProvider("https://rpc.gnosischain.com/"));
    highRateWeb3 = new Web3(new Web3.providers.HttpProvider("https://rpc.gnosis.gateway.fm"));

    trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
      currentUser = res.username

      cognitoID = res.signInUserSession.idToken.jwtToken
      currentUserCap = currentUser.toUpperCase()

      if(currentUserCap.length > 11){
        currentUserCap = currentUserCap.substring(0, 11).concat('..')
      }
      
    });

    that = this;

    
    
  }

  componentDidMount(){
        
      if(isMobile){
        // window.open("https://lenderblockcorp.com/blenderplatform","_self")
      }
  
      that.setState({
        selectedLanguage: localStorage.getItem('primaryLanguage'),
        mode_light_dark: localStorage.getItem('mode_light_dark'),
        errorTags: null,
        pendingTransactionLoaderOverlay: false,
        transferCommissionPercentDecimal: 0.05,
        moneyTransferOverlay: false,
      })

      trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
        currentUser = res.username

        cognitoID = res.signInUserSession.idToken.jwtToken
        currentUserCap = currentUser.toUpperCase()


        let allUserUsernamesDisplayNames = localStorage.getItem('allUserUsernamesDisplayNames')
        if(!allUserUsernamesDisplayNames){
          authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
              category: 'db',
              tableName: 'general', 
              primaryKey: 'userArray', 
              requestOperation: 'get',
            }
          }).then((_userArray) => {
            let userArray = _userArray.Item.userArray;
            let allUserUsernamesDisplayNames = []
            function loopAllUsers(u){
              if(u<=userArray.length-1){
                let thisUser = userArray[u];
                allUserUsernamesDisplayNames.push(
                  {
                    id: allUserUsernamesDisplayNames.length,
                    name: thisUser
                  }
                )
                loopAllUsers(u+1)
              } else {
                that.setState({
                  allUserUsernamesDisplayNames
                }, () => {
                  localStorage.setItem('allUserUsernamesDisplayNames', JSON.stringify(allUserUsernamesDisplayNames))
                })
              }
            }
            loopAllUsers(0)
          })
        } else {
          that.setState({
            allUserUsernamesDisplayNames: JSON.parse(allUserUsernamesDisplayNames)
          })
        }


        that.setState({
          currentUser
        })

        let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${currentUser.toLowerCase()}`;

        that.setState({
          currentUserProfilePicture: profilePicture_uri
        })

        Storage.get(
          `${currentUser.toLowerCase()}/profilePicture.jpg`,
          {
              bucket: "platform-user-media-uploads",
              level: "public"
          }
        ).then((res) => {
          trackPageRequest(fetch(
            res
          )).then((image) => {
            if(image.status == 200){
              profilePicture_uri = res;
            }
            that.setState({
              currentUserProfilePicture: profilePicture_uri
            })
          })
        })

        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'users', 
            primaryKey: String(currentUser), 
            requestOperation: 'get',
          }
        }).then((userData) => {
          primaryDisplayCurrency = userData.Item.preferences.primaryDisplayCurrency
          secondaryDisplayCurrency = userData.Item.preferences.secondaryDisplayCurrency
          

          

          that.setState({
            primaryDisplayCurrency,
            secondaryDisplayCurrency
          })

          if(currentUserCap.length > 11){
            currentUserCap = currentUserCap.substring(0, 11).concat('..')
          }
        
          
          that.setState({ currentUser, currentUserCap })


          publicKey = userData.Item.publicKey

          if(web3.utils.isAddress(publicKey)){

            trackPageRequest(web3.eth.getBalance(publicKey)).then((balance) => {

              walletBalanceWei = Math.max(
                0,
                Number(balance) - (2000000 * 4000000000)
              )

              that.setState({
                walletBalanceUSD: walletBalanceWei / 1000000000000000000,
                walletBalanceWei: walletBalanceWei,
                maxWalletWithdrawalWei: walletBalanceWei,
                publicKey: publicKey,
              })

            }).catch((err) => {

            })

          } else {

            

          }


          that.formContents()
        });
      })
      
  
  }
  

  

  withdrawEther(){
    // Legacy bank/card payment path replaced by the shared CryptoMoneyPanel.
    return;
  }

  

  sendTransferFinal(){

    that.setState({
      pendingTransactionLoaderOverlay: true,
    })

    let weiTransferValue = parseInt(Number(that.state.moneyTransactionLiveValue)*1000000000000000000, 10)
    let transferValueUSD = Number(that.state.moneyTransactionLiveValue);

    let destinationUsername = String(that.state.destinationUsername).split(" ").join("")
    let destinationAddress;
    let recipientUser;
    let randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    let randomString2 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    randomString1 =  randomString1.substring(0,18)
    randomString2 =  randomString2.substring(0,18)

    that.setState({
        showPageLoader: true,
        showPasswordOverlay: false,
        password: String(that.state.passwordText).replace(/\s/g, '')
    })

    if(that.state.destinationUsername != null){

            recipientUser = destinationUsername.toLowerCase()
            that.setState({
              recipientUser
            })

            authenticatedPut('api1169ba1e', '', { 
                headers: { Authorization: `Bearer ${cognitoID}` },
                body: { 
                category: 'db',
                tableName: 'users', 
                primaryKey: recipientUser.toLowerCase(), 
                requestOperation: 'get',
                }
            }).then((recipient) => {
              if(recipient.hasOwnProperty('Item')){
                  destinationAddress = recipient.Item.publicKey
              

                  let recipientFirstName = recipient.Item.firstName
                  let recipientEmailAddress = recipient.Item.emailAddress


                  authenticatedPut('api1169ba1e', '', { 
                      headers: { Authorization: `Bearer ${cognitoID}` },
                      body: { 
                        category: 'db',
                        tableName: 'users', 
                        primaryKey: currentUser, 
                        requestOperation: 'get',
                      }
                  }).then(async (response) => {

                      let publicKey = response.Item.publicKey
                      let emailAddress = response.Item.emailAddress
                      let firstName = response.Item.firstName
                      let privateKey = response.Item.privateKey

                      let bytes = CryptoJS.AES.decrypt(String(privateKey), that.state.passwordText);


                      var plaintextPK

                      // Recipient amount + Blender commission equals the entered total.
                      // The commission is not charged twice; reserve gas for both transactions.
                      const transferNetworkFeeWei = ethers.BigNumber.from('200000').mul('1200000000').mul(2);
                      let confirmedBalanceWei;
                      try {
                        const liveBalance = await highRateWeb3.eth.getBalance(publicKey);
                        confirmedBalanceWei = ethers.BigNumber.from(String(liveBalance));
                      } catch (balanceError) {
                        that.setState({
                          errorTags: <p style={{ textAlign: 'left' }}>
                            {that.state.selectedLanguage == 'spanish'
                              ? 'No se pudo verificar el saldo de tu Cartera Blender. Inténtalo de nuevo.'
                              : 'Could Not Verify Your Blender Wallet Balance. Please Try Again.'}
                          </p>,
                          showInsufficientFundsOverlay: false,
                          showConfirmationOverlay: false,
                          pendingTransactionLoaderOverlay: false,
                          showPageLoader: false,
                          disableWhileTxn: false,
                        });
                        return;
                      }
                      const transferSpendableWei = confirmedBalanceWei.gt(transferNetworkFeeWei)
                        ? confirmedBalanceWei.sub(transferNetworkFeeWei) : ethers.constants.Zero;
                      const transferAmountWei = ethers.utils.parseEther(String(that.state.moneyTransactionLiveValue).trim());

                      if(transferAmountWei.gt(0) && transferAmountWei.lte(transferSpendableWei)){
                        try{
                          plaintextPK = bytes.toString(CryptoJS.enc.Utf8);
                          finishTxn()
                        } catch(err){
                          
                          
                          that.setState({
                            errorTags: 
                              <p style={{ textAlign: 'left', }}>
                                {that.state.selectedLanguage == 'spanish' ? 
                                  'Contraseña no Válida'
                                    :
                                  'Incorrect Password'
                                }
                              </p>,
                              showInsufficientFundsOverlay: false,
                              showConfirmationOverlay: false,
                              pendingTransactionLoaderOverlay: false,
                              showPageLoader: false,
                              password: null,
                              actionValue: null,
                              disableWhileTxn: false,
                          })
                        }
                      } else {
                        
                        that.setState({
                          errorTags: 
                            <p style={{ textAlign: 'left', }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                `El valor máximo de transferir desde tu cartera Blender es ${(Math.floor(Number(ethers.utils.formatEther(transferSpendableWei)) * 100) / 100).toFixed(2)} USD`
                                  :
                                `The maximum transfer value from your Blender Wallet is ${(Math.floor(Number(ethers.utils.formatEther(transferSpendableWei)) * 100) / 100).toFixed(2)} USD`
                              }
                            </p>,
                            showInsufficientFundsOverlay: false,
                            showConfirmationOverlay: false,
                            pendingTransactionLoaderOverlay: false,
                            showPageLoader: false,
                            password: null,
                            actionValue: null,
                            disableWhileTxn: false,
                        })
                      }

                      function finishTxn(){

                          plaintextPK = plaintextPK.substring(64, plaintextPK.length-64) 

                        
                          let mnemonicWallet = ethers.Wallet.fromMnemonic(plaintextPK);
                          var plaintextMnemonic = mnemonicWallet.privateKey

                          highRateWeb3.eth.getTransactionCount(publicKey).then((_nonce) => {
                          
                            const nonce = _nonce;

                            const tx_sendTransfer = { 
                              chainId: 100,
                              gas: '200000',
                              gasPrice: String(1200000000),
                              from: publicKey, 
                              to: destinationAddress, 
                              value: (Number(weiTransferValue)*(1-that.state.transferCommissionPercentDecimal)).toLocaleString('fullwide', {useGrouping: false}),
                              data: "",
                              nonce: nonce
                            }
  
                            const tx_sendTransfer_commission = { 
                              chainId: 100,
                              gas: '200000',
                              gasPrice: String(1200000000),
                              from: publicKey, 
                              to: blenderCommissionPublicKey, 
                              value: (Number(weiTransferValue)*that.state.transferCommissionPercentDecimal).toLocaleString('fullwide', {useGrouping: false}),
                              data: "",
                              nonce: nonce+1
                            }

                            var tx_sendTransfer_receipt;

                            highRateWeb3.eth.accounts.signTransaction(tx_sendTransfer_commission, plaintextMnemonic)
                              .then((signedTx_sendTransferCommission) => {
                              
                                
                                highRateWeb3.eth.accounts.signTransaction(tx_sendTransfer, plaintextMnemonic)
                                  .then((signedTx_sendTransfer) => {


                                    highRateWeb3.eth.sendSignedTransaction(signedTx_sendTransfer.rawTransaction).then((_tx_sendTransfer_receipt) => {
                                      tx_sendTransfer_receipt = _tx_sendTransfer_receipt.transactionHash
                                    }).then((res) => {

                                      highRateWeb3.eth.sendSignedTransaction(signedTx_sendTransferCommission.rawTransaction).then((receipt) => {

                                        if(that.state.selectedLanguage == 'spanish'){
                                          if(that.state.isSubscribedCurrentBool){
                                            that.setNativeNotification(`Blender Pro Plus Ahorros - Has guardado ${Number(Number(transferValueUSD)*0.05).toFixed(2)} USD por transferir a ${String(recipientUser).toUpperCase()}!`)
                                          } else {
                                            that.setNativeNotification(`Transferiste ${Number(transferValueUSD).toFixed(2)} USD a ${String(recipientUser).toUpperCase()}!`)
                                          }
                                        } else {
                                          if(that.state.isSubscribedCurrentBool){
                                            that.setNativeNotification(`Blender Pro Plus Savings - You saved ${Number(Number(transferValueUSD)*0.05).toFixed(2)} USD transferring to ${String(recipientUser).toUpperCase()}!`)
                                          } else {
                                            that.setNativeNotification(`You transferred ${Number(transferValueUSD).toFixed(2)} USD to ${String(recipientUser).toUpperCase()}!`)
                                          }
                                        }


                                        authenticatedPut('api1169ba1e', '', { 
                                          headers: { Authorization: `Bearer ${cognitoID}` },
                                          body: { 
                                              category: 'db',
                                              tableName: 'pendingTransactions', 
                                              primaryKey: tx_sendTransfer_receipt, 
                                              requestOperation: 'update',
                                              updateExpression: 
                                              `SET 
                                                  transactionType = :txnType,
                                                  creationDate = :creationDate, 
                                                  creationDateSecs = :creationDateSecs, 
                                                  #st = :status, 
                                                  currentUser = :currentUser,
                                                  publicKey = :publicKey,
                                                  emailType = :emailType,
                                                  firstName = :firstName,
                                                  emailAddress = :emailAddress,
                                                  adjustedWeiValueNum = :adjustedWeiValueNum,
                                                  recipientUser = :recipientUser,
                                                  recipient = :recipient,
                                                  recipientEmailAddress = :recipientEmailAddress,
                                                  recipientFirstName = :recipientFirstName,
                                                  randomString1 = :randomString1,
                                                  randomString2 = :randomString2,
                                                  application = :application,
                                                  currency = :currency,
                                                  conversionRateGlobal = :conversionRateGlobal
                                              `,
                                              expressionAttributeNames: {"#st":"status"},
                                              expressionAttributeValues: { 
                                                  ':txnType': 'transfer',
                                                  ':creationDate': new Date(),
                                                  ':creationDateSecs': Date.now(), 
                                                  ':currentUser': currentUser,
                                                  ':status': 'active',
                                                  ':publicKey': publicKey,
                                                  ':emailAddress': emailAddress,
                                                  ':emailType': 'contribution',
                                                  ':firstName': firstName,
                                                  ':adjustedWeiValueNum': Number(weiTransferValue) * (-1),
                                                  ':recipientUser': recipientUser,
                                                  ':recipient': destinationAddress,
                                                  ':randomString1': randomString1,
                                                  ':randomString2': randomString2,
                                                  ':recipientEmailAddress': recipientEmailAddress,
                                                  ':recipientFirstName': recipientFirstName,
                                                  ':application': 'TBP',
                                                  ':currency': 'USD',
                                                  ':conversionRateGlobal': 1
                                              }
                                          }
                                          }).then((res) => {

                                              authenticatedPut('api1169ba1e', '', { 
                                                headers: { Authorization: `Bearer ${cognitoID}` },
                                                body: { 
                                                    category: 'db',
                                                    tableName: 'general', 
                                                    primaryKey: 'txnHash', 
                                                    requestOperation: 'update',
                                                    updateExpression: `SET txnHash = list_append(txnHash, :txnHash)`, 
                                                    expressionAttributeValues: { 
                                                      ':txnHash': [tx_sendTransfer_receipt]
                                                    }
                                                }
                                              }).then((res) => {

                                                if(that.state.isSubscribedCurrentBool){
                                                  that.setState({
                                                    successSubscriberSavingsOverlay: true,
                                                    pendingTransactionLoaderOverlay: false,
                                                  })
                                                } else {
                                                  that.setState({
                                                    pendingTransactionLoaderOverlay: false,
                                                    successfulTransferOverlay: true,
                                                    pendingTransactionLoaderOverlay: false,
                                                  })
                                                }

                                                that.setState({
                                                    showInsufficientFundsOverlay: false,
                                                    showConfirmationOverlay: false,
                                                    showPasswordOverlay: false,
                                                    showPageLoader: false,
                                                    password: null,
                                                    actionValue: null,
                                                    disableWhileTxn: false,
                                                })
                                                setTimeout(() => {
                                                  that.setState({
                                                    successfulTransferOverlay: false,
                                                    successSubscriberSavingsOverlay: false,
                                                  })
                                                }, 3000)
                                          })
                                      })




                                      }).catch((err) => {
                                      })
                                    }).catch((err) => {
                                    });

                                }).catch((err) => {
                                })
                              }).catch((err) => {
                              });
                          })

                          plaintextPK = null
                          privateKey = null

                      }
                  })
              } else{
                
                that.setState({
                  errorTags: 
                    <p
                      style={{
                        textAlign: 'left',
                      }}
                    >
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Recipiente no Válida'
                          :
                        'Invalid Recipient'
                      }
                    </p>,
                  showPasswordOverlay: false,
                  pendingTransactionLoaderOverlay: false,
                })
              }
          })


    }
  }
  
  chargeUserLinked(){
    // Legacy bank/card payment path replaced by the shared CryptoMoneyPanel.
    return;
  }
  
  

  formContents(){
    let receiptPushedCt = 0;
    let receiptList = []

      that.setState({
        trigger: 'on',
        showOverlay: false,
        receiptList: [],
      })

      authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'users', 
            primaryKey: currentUser, 
            requestOperation: 'get',
          }
      }).then(response => {
          let receipts = response.Item.receipts
          publicKey = response.Item.publicKey.toUpperCase()
          let receiptsChecklist = []
          for(let i=0; i<=receipts.length-1; i++){
              if(!receiptsChecklist.includes(receipts[i])){
              
                receiptsChecklist.push(receipts[i])

                authenticatedPut('api1169ba1e', '', { 
                    headers: { Authorization: `Bearer ${cognitoID}` },
                    body: { 
                      category: 'db',
                      tableName: 'receipts', 
                      primaryKey: receipts[i], 
                      requestOperation: 'get',
                    }
                }).then(response => {
                  if(response.hasOwnProperty('Item')){
                    if(response.Item.hasOwnProperty('actionType')){
                          let lookupKey = null;
                          let actionType = response.Item.actionType
                          let dateNow = String(response.Item.dateNow).substring(0,10)
                          let dateSecs = response.Item.dateNow
                          let manager = response.Item.manager
                          let receiptID = response.Item.receiptID
                          let value = response.Item.value
                          let contractAddress = response.Item.contractAddress
                          let applicationPlatform = response.Item.applicationPlatform
                          
                          receiptID = parseInt(String(receiptID).substring(0,12), 10)
                          actionType = String(actionType).toUpperCase()
                          dateNow = String(dateNow)
                          let monthNum = dateNow.substr(5,2)
                          let yearNum = dateNow.substr(0,4)
                          let dayNum = dateNow.substr(8,2)
                          let monthString
                          if(monthNum == '01'){
                            monthString = 'Jan. '
                          } else if(monthNum == '02'){
                            monthString = 'Feb. '
                          } else if(monthNum == '03'){
                            monthString = 'Mar. '
                          } else if(monthNum == '04'){
                            monthString = 'Apr. '
                          } else if(monthNum == '05'){
                            monthString = 'May. '
                          } else if(monthNum == '06'){
                            monthString = 'Jun. '
                          } else if(monthNum == '07'){
                            monthString = 'Jul. '
                          } else if(monthNum == '08'){
                            monthString = 'Aug. '
                          } else if(monthNum == '09'){
                            monthString = 'Sep. '
                          } else if(monthNum == '10'){
                            monthString = 'Oct. '
                          } else if(monthNum == '11'){
                            monthString = 'Nov. '
                          } else if(monthNum == '12'){
                            monthString = 'Dec. '
                          } 
                          dateNow = monthString + dayNum + ', ' + yearNum
                          manager = String(manager).toUpperCase()
                          receiptID = String(receiptID)
                          value = Math.abs(Number(value)).toFixed(3)


                          if(contractAddress){

                            contractAddress = String(contractAddress)

                            authenticatedPut('api1169ba1e', '', { 
                              headers: { Authorization: `Bearer ${cognitoID}` },
                              body: { 
                                category: 'db',
                                tableName: 'contracts', 
                                primaryKey: contractAddress, 
                                requestOperation: 'get',
                              }
                            }).then(response => {

                              if(response.hasOwnProperty('Item')){
                                if(response.Item.hasOwnProperty('lookupKey')){
                                  lookupKey = response.Item.lookupKey;
                                } else {
                                  pushReceipt()
                                }
                              } else {
                                pushReceipt()
                              }
                              pushReceipt()
                            })
                          } else {
                            pushReceipt()
                          }


                        function pushReceipt(){
                          if(value == 'null'){
                            value = '-'
                          } else {
                            value = parseFloat(value) 
                            value = Number(value, 10) / 1000000000000000000

                            if(Math.abs(value) < 0.001){
                              value = 0
                            }
                            value = Number(value).toFixed(2)
                          }
                          
                          let date = new Date(dateSecs); 
                          let milliseconds = date.getTime();      
                          let elapsedDays = Math.floor(Date.now() - milliseconds)/86400000
                          let valueColor

                          if(Number(value)>0){
                            valueColor =  'rgba(0, 158, 129, 1)'
                          } else if(Number(value)<0){
                            valueColor = 'rgba(204, 12, 12, .70)'
                          } else {
                            valueColor =  'rgba(0, 158, 129, 1)'
                          }


                          if(actionType == 'NEW CONTRACT'){
                            value = '0.00'
                          }


                          if(
                            actionType.toLowerCase() == 'transfer out' ||
                            actionType.toLowerCase() == 'withdrawal' 
                          ){
                            valueColor = 'rgba(204, 12, 12, .70)'
                          }

                          if(that.state.selectedLanguage == 'spanish'){
                            
                            if(actionType == 'COLLATERAL INCREASE'){
                              actionType = 'COLATERAL AUMENTADO'
                            }

                            if(actionType == 'PAYMENT'){
                              actionType = 'PAGO DADO'
                            }

                            if(actionType == 'PAYMENT RECEIVED'){
                              actionType = 'PAGO RECIBIDO'
                            }

                            if(actionType == 'CONTRIBUTION'){
                              actionType = 'CONTRIBUCIÓN PRESTADA'
                            }

                            if(actionType == 'TRANSFER OUT'){
                              actionType = 'TRANSFERENCIA SALIENTE'
                            }

                            if(actionType == 'TRANSFER IN'){
                              actionType = 'TRANSFERENCIA ENTRANTE'
                            }

                            if(actionType == 'RECLAIM'){
                              actionType = 'RECLAMAR'
                            }

                            if(actionType == 'WITHDRAWAL'){
                              actionType = 'RETIRO A BANCA'
                            }

                            if(actionType == 'EXT. DEPOSIT'){
                              actionType = 'DEPOSITO A CARTERA'
                            }

                            if(actionType == 'STAKE'){
                              actionType = 'APOSTAR'
                            }

                            if(actionType == 'NEW CONTRACT'){
                              actionType = 'LÍNEA CREADA'
                            }

                          } else {
                            
                            if(actionType == 'COLLATERAL INCREASE'){
                              actionType = 'COLATERAL INCREASE'
                            }

                            if(actionType == 'PAYMENT'){
                              actionType = 'REPAYMENT GIVEN'
                            }

                            if(actionType == 'PAYMENT RECEIVED'){
                              actionType = 'REPAYMENT RECEIVED'
                            }

                            if(actionType == 'CONTRIBUTION'){
                              actionType = 'LENDING CONTRIBUTION'
                            }

                            if(actionType == 'TRANSFER OUT'){
                              actionType = 'TRANSFER OUT'
                            }

                            if(actionType == 'TRANSFER IN'){
                              actionType = 'TRANSFER IN'
                            }

                            if(actionType == 'RECLAIM'){
                              actionType = 'RECLAIM'
                            }

                            if(actionType == 'WITHDRAWAL'){
                              actionType = 'WITHDRAWAL TO BANK'
                            }

                            if(actionType == 'EXT. DEPOSIT'){
                              actionType = 'WALLET DEPOSIT'
                            }

                            if(actionType == 'STAKE'){
                              actionType = 'STAKE'
                            }

                            if(actionType == 'NEW CONTRACT'){
                              actionType = 'NEW CREDIT LINE'
                            }

                          }

                          if(actionType != 'NEW ACCOUNT' && that.state.chartDayRange >= elapsedDays && applicationPlatform == 'TBP'){
                    
                              receiptPushedCt += 1
                              receiptList.push({
                                actionType,
                                dateNow,
                                dateSecs,
                                contractAddress,
                                contractLookupID: lookupKey,
                                receiptID,
                                value,
                                manager,
                                valueColor
                              })
                          
                        
                          } else {
                            receiptPushedCt += 1
                          }

                          if(receiptPushedCt == receipts.length-1){
                            receiptList.sort((a, b) => (a.receiptID < b.receiptID) ? 1 : -1)

                            that.setState({ 
                              receiptList,
                              publicKey,
                              receiptCount: receiptList.length,
                            })
                          }
                        }
                      } else {
                        receiptPushedCt += 1
                      }
                    } else {
                      receiptPushedCt += 1
                    }
                })
              } else {
                receiptPushedCt += 1
              }
          }        
      })
  

  }

  componentWillUnmount() { 

  }

  setNativeNotification(generalNoticeText){
    that.setState({
      generalNoticeOverlay: true,
      generalNoticeText
    })
  }

  render(){
    
      const { touched } = that.state;
      const className = touched ? 'button1_touched' : 'button1';


      if(navigationHandler(that.state.navigationDestinationObject)){
          return navigationHandler(that.state.navigationDestinationObject)
      }
      const renderProps = { API, AWS, Amplify, Auth, Bar, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, CartesianGrid, Chart, Component, Container, CryptoJS, Form, FormField, Fragment, Header, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, Legend, Line, LineChart, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, MemberTransactions, Modal, Mosaic, OrbitProgress, Radio, React, ReactSearchAutocomplete, ResponsiveContainer, Storage, ThreeDot, Tooltip, Web3, XAxis, YAxis, _approverReceivedRepaymentSum, _approversCt, _approversLoanTotal, _availableCreditReadyWithdraw, _balance, _blenderScore, _blockchainBalance, _borrowerInterestPaid, _borrowingRec, _canDeleteCreditLineBool, _compoundedBalance, _compoundedBalanceWEI, _currentUserContribution, _dateCreated, _exitReclaimableValueWei, _fico, _intRate, _joinDate, _lenders, _lendingRate, _lentTotal, _loanRate, _lookupKey, _managerLCase, _minLoan, _offeredLenderCommissionUSD_adjusted, _openValue, _payableValue, _reclaimableValue, _repayRate, _repaymentTotal, _riskCoverage, _safeReclaimableValueWei, _targetValue, _totalBorrowing, _totalContributed, _totalContributedWei, _totalLending, _totalPaid, _totalWithdrawn, _txnSectionHelpText, _userAvgRating, _userContributed, _userFinalized, _userInterestEarned, _values, _valuesONLY, _web3Balance, _weiCompoundedBalance, _withdrawalRate, accountStatsArray, actionButton, actionText, actionType, actionTypeStakingBool, approverCheck, approverReceivedRepaymentSum, approversCount, approversList, availableCredit, availableCreditRatio, availableCredit_unadjusted, awsconfig, axios, blacklisted, blenderCommissionPublicKey, blenderPercentCharge, blenderPrivateKey, blenderScore, blenderTransfersToPublicKey, borrowerInterestPaid, borrowerStatsArray, borrowingRec, buttonColorFlashIntervalDefault, buttonColorFlashIntervalSecondary, buttonText, campaign, checkValidAuthTokenIntervalPeriod_ms, className, client, closureDateFormatted, cognitoID, compoundInterestReceived, compoundedInterestPaid, contractAddress, contractBalance, contractReceipts, contractStructureType, contributeSignatureNeeded, conversionRateGlobal, corporateBackedUsernamesArray, costText, creditUtilizationPerc, currentUser, currentUserCap, currentUserLoanTotal, dataIndexDayMap, deploymentAddress, displayValue, dob, emailAddress, errorWarningOverlayTimeout, ethers, fico, finalRequestsSum, firstName, forexJSON, formattedValueTooltipString, fullAddress, highRateWeb3, imaginaryInsuranceTotal, insuranceTotal, intRate, interactionHeader, interestRate, ipAddress, isCorporateBondBool, isMobile, isSubscribedCurrentBool, lastName, lenderCount, lendingRate, loadingTextInterval, loadingTextIntervalCt, loanRate, loanTarget, manager, managerDisplay, managerUsername, maxDayValue, mediaArray, mediaArrayMap, mediaMapArrayUserMap, mimemessage, minDayValue, minLoan, minimumContribution, mode_light_dark, monthLengtheningEnum, navigationHandler, netDebt, noDailyDataPointsFoundBool, offeredLenderCommissionUSD, openContracts, openValue, phoneNumber, primaryDisplayCurrency, primaryDisplayPrice, primaryLanguage, privateKey, proposeGasPrice, publicKey, rand1, receiptsCt, reclaimableValue, region, repaidRec, repayRate, repaymentSum, requests, requestsCt, riskCoveragePercentage, routeProps, secondaryDisplayCurrency, secondaryDisplayPrice, secretName, settlementDateFormatted, squareCustomerID, streetAddress, targetValue, that, thisContract_CampaignContract, thisContract_CampaignFactoryContract, thisDeploymentAddress, tokenLifeTimeLimit, tooltipInterval, totalBorrowing, totalContributed, totalCreditMax, totalLending, totalPaid, totalValue, totalWithdrawn, touched, transactionValue, useLayoutEffect, useParams, useRef, userContributed, userFinalized, userFinalizedRequestLoanSum, userInterestEarned, userLiquidValue, userLiquidValuePre, userRiskValue, value, valueDelta, walletBalanceWei, web3, web3BalancePost, web3BalancePre, wishlist, wishlistIcon, withdrawalRate };

      if (isMobile) {
        return <MemberTransactionsMobileRender {...renderProps} />;
      }

      return <MemberTransactionsDesktopRender {...renderProps} />;
    }





}


function MemberTransactions(props){
  const {contractAddress} = useParams();

  return (<MemberTransactionsComponent contractAddress={contractAddress}/>)
}

export default MemberTransactions;

